import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { VTLMaterial as t } from "./VTLMaterial.js";

var o = /*#__PURE__*/function (_t) {
  _inherits(o, _t);

  var _super = _createSuper(o);

  function o(t) {
    _classCallCheck(this, o);

    return _super.call(this, t);
  }

  _createClass(o, [{
    key: "geometryInfo",
    value: function geometryInfo() {
      return o.GEOMETRY_LAYOUT;
    }
  }, {
    key: "opacityInfo",
    value: function opacityInfo() {
      return null;
    }
  }, {
    key: "attributes",
    value: function attributes() {
      return o.ATTRIBUTES;
    }
  }, {
    key: "attributesInfo",
    value: function attributesInfo() {
      return o.ATTRIBUTES_INFO;
    }
  }]);

  return o;
}(t);

o.ATTRIBUTES = ["fill-color", "fill-opacity", "fill-pattern"], o.GEOMETRY_LAYOUT = [{
  name: "a_pos",
  count: 2,
  type: 5122,
  offset: 0,
  stride: 4,
  normalized: !1,
  divisor: 0
}], o.ATTRIBUTES_INFO = {
  "fill-color": {
    name: "color",
    type: 10
  },
  "fill-opacity": {
    name: "opacity",
    type: 1,
    precisionFactor: 100
  },
  "fill-pattern": {
    name: "tlbr",
    type: 12,
    isOptional: !0
  }
};

var e = /*#__PURE__*/function (_t2) {
  _inherits(e, _t2);

  var _super2 = _createSuper(e);

  function e(t, o) {
    var _this;

    _classCallCheck(this, e);

    _this = _super2.call(this, t), _this.usefillColor = o;
    return _this;
  }

  _createClass(e, [{
    key: "geometryInfo",
    value: function geometryInfo() {
      return e.GEOMETRY_LAYOUT;
    }
  }, {
    key: "opacityInfo",
    value: function opacityInfo() {
      return null;
    }
  }, {
    key: "attributes",
    value: function attributes() {
      return this.usefillColor ? e.ATTRIBUTES_FILL : e.ATTRIBUTES_OUTLINE;
    }
  }, {
    key: "attributesInfo",
    value: function attributesInfo() {
      return this.usefillColor ? e.ATTRIBUTES_INFO_FILL : e.ATTRIBUTES_INFO_OUTLINE;
    }
  }]);

  return e;
}(t);

e.ATTRIBUTES_OUTLINE = ["fill-outline-color", "fill-opacity"], e.ATTRIBUTES_FILL = ["fill-color", "fill-opacity"], e.GEOMETRY_LAYOUT = [{
  name: "a_pos",
  count: 2,
  type: 5122,
  offset: 0,
  stride: 8,
  normalized: !1,
  divisor: 0
}, {
  name: "a_offset",
  count: 2,
  type: 5120,
  offset: 4,
  stride: 8,
  normalized: !1,
  divisor: 0
}, {
  name: "a_xnormal",
  count: 2,
  type: 5120,
  offset: 6,
  stride: 8,
  normalized: !1,
  divisor: 0
}], e.ATTRIBUTES_INFO_OUTLINE = {
  "fill-outline-color": {
    name: "color",
    type: 10
  },
  "fill-opacity": {
    name: "opacity",
    type: 1,
    precisionFactor: 100
  }
}, e.ATTRIBUTES_INFO_FILL = {
  "fill-color": {
    name: "color",
    type: 10
  },
  "fill-opacity": {
    name: "opacity",
    type: 1,
    precisionFactor: 100
  }
};
export { o as VTLFillMaterial, e as VTLOutlineMaterial };